import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay-loading-page" }

import { VueSpinnerDots } from "vue3-spinners";


export default /*@__PURE__*/_defineComponent({
  __name: 'PageLoading',
  props: {
  text: {
    type: String,
    default: "Loading...",
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VueSpinnerDots), {
      size: "50",
      color: "black"
    }),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-loading mt-3" }, "Processing Data...", -1))
  ]))
}
}

})